




































































































import Vue from 'vue'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { FETCH_RECRUITING_DATA } from '@/store/action-types'
import { DatePeriodEnum, SnackbarStateEnum } from '@/types/enums'
import RecruitingDetailDialog from '@/components/recruiting/RecruitingDetailDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import Kanban from '@/components/cockpit/Kanban.vue'
import PeriodSelector from '@/components/PeriodSelector.vue'
import { DatePeriod } from '@/model/DatePeriod'

interface ComponentData {
  tableHeight: string,
  loading: boolean
  showSnackbar: boolean,
  snackbarState: number,
  messageSnackbar: string,

  currentPeriod: DatePeriod
  period: DatePeriodEnum
  searchText: string | null
  showSearchField: boolean
  recruitingData: any[]
  selectedRecruitingItem: any | null
  showDetailDialog: boolean

  selectedTask: any | null
  isKanbanCreate: boolean
  isKanbanEdit: boolean
  isKanbanDelete: boolean
}

export default Vue.extend({
  name: 'RecruitingPage',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxStateStoring,
    RecruitingDetailDialog,
    PeriodSelector,
    Kanban
  },

  props: {
    recruitingGroupId: Number,
    search: String
  },

  data (): ComponentData {
    const currentPeriod: DatePeriod = DatePeriod.createFromNow(DatePeriodEnum.Month)

    return {
      tableHeight: '',
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      currentPeriod: currentPeriod,
      period: DatePeriodEnum.Month,
      searchText: null,
      showSearchField: false,
      recruitingData: [],
      selectedRecruitingItem: null,
      showDetailDialog: false,

      selectedTask: null,
      isKanbanCreate: false,
      isKanbanEdit: false,
      isKanbanDelete: false
    }
  },

  watch: {
    recruitingGroupId (newVal: number): void {
      if(newVal) {
        //@ts-ignore
        //this.$refs.dataGrid.instance.selectRows([])
        this.selectedRecruitingItem = null
        this.fetchRecruitingData()
      }
    },

    search (newVal): void {
      this.searchText = this.search ? this.search : null
      this.showSearchField = !!this.searchText
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isSearchEnabled (): boolean {
      return this.recruitingData.length > 0
    },

    filteredRecruitingData (): any[] {
      if(this.searchText) {
        return this.recruitingData.filter((item: any) => `${item.name.toLowerCase()}${item.vorname.toLowerCase()}`.includes(this.searchText!))
      } else {
        return this.recruitingData
      }
    }
  },

  methods: {
    selectTask (item: any | null): void {
      this.selectedTask = item
    },

    stopCreate (): void {
      this.isKanbanCreate = false
    },

    stopEdit (): void {
      this.isKanbanEdit = false
    },

    stopDelete (): void {
      this.isKanbanDelete = false
    },

    isTextButton (item: string): boolean {
      return this.period === item
    },

    periodButtonColor (item: string): string {
      return this.period === item  ? 'primary' : 'secondary'
    },

    onYearPeriodClick (): void {
      this.period = DatePeriodEnum.Year
    },

    onMonthPeriodClick (): void {
      this.period = DatePeriodEnum.Month
    },

    onWeekPeriodClick (): void {
      this.period = DatePeriodEnum.Week
    },

    onWorkingWeekPeriodClick (): void {
      this.period = DatePeriodEnum.WorkingWeek
    },

    onDayPeriodClick (): void {
      this.period = DatePeriodEnum.Day
    },

    onPeriodSelected (period: DatePeriod): void {
      this.currentPeriod = period
    },

    onRefreshClick (): void {
    },

    onAddTaskClick (): void {
    },

    onEditTaskClick (): void {
    },

    onDeleteTaskClick (): void {
      this.isKanbanDelete = true
    },

    onDetailDialogClose (): void {
      this.showDetailDialog = false
    },

    onAddRecruitingClick(): void {
      this.selectedRecruitingItem = {}
      //@ts-ignore
      //this.$refs.dataGrid.instance.selectRows([])
      this.showDetailDialog = true
    },

    onEditRecruitingClick(): void {
      this.showDetailDialog = true
    },

    rowClick(event: any): void {
      this.selectedRecruitingItem = event.data
    },

    rowDblClick(event: any): void {
      this.selectedRecruitingItem = event.data
      this.showDetailDialog = true
    },

    async fetchRecruitingData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_RECRUITING_DATA)
        this.recruitingData = response
        /*if(!response.IsError) {
          this.recruitingData = response.Results
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }*/

      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.loading = false
      }
    },

    onResize (): void {
      if(this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          this.tableHeight = `height: calc(${vh}px - 136px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted() {
    this.searchText = this.search ? this.search : null
    this.showSearchField = !!this.searchText
    this.fetchRecruitingData()
    //@ts-ignore
    //setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)
  }
})
